import React from 'react'
import PropTypes from 'prop-types'

import StandardModal from './StandardModal'
import { openAppStore } from '../../utils/appStoreLinks'

const DownloadAppModal = ({ onClose }) => (
  <StandardModal onClose={onClose} title="Download Lexody">
    <div className="downloadAppModal">
      <h3 className="downloadAppModal__title">Get the Lexody app</h3>
      <p className="downloadAppModal__text">
        This activity is only available in the mobile app. Choose your platform to download.
      </p>
      <div className="downloadAppModal__actions">
        <button
          type="button"
          className="downloadAppModal__btn downloadAppModal__btn--ios"
          onClick={() => openAppStore('ios')}
        >
          Download for iOS
        </button>
        <button
          type="button"
          className="downloadAppModal__btn downloadAppModal__btn--android"
          onClick={() => openAppStore('android')}
        >
          Download for Android
        </button>
      </div>
    </div>
  </StandardModal>
)

DownloadAppModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default DownloadAppModal
